import { Component, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'magic-ai-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class MagicAiVideoSectionComponent implements AfterViewInit {

  isPortrait;

  constructor(private elementRef: ElementRef) {
    this.isPortrait = window.innerWidth <= window.innerHeight;
  }

  ngAfterViewInit() {
    this.initVideo();
  }

  initVideo() {
    const videoMetaUrl = this.isPortrait ?
      'https://fast.wistia.com/embed/medias/r6fqxtrtcx.jsonp' :
      'https://fast.wistia.com/embed/medias/if218vdgzs.jsonp';

    this.appendScript(videoMetaUrl);
    this.appendScript('https://fast.wistia.com/assets/external/E-v1.js');
  }

  appendScript(src) {
    const tag = document.createElement('script');
    tag.src = src;
    this.elementRef.nativeElement.appendChild(tag);
  }
}
